import { render, staticRenderFns } from "./GastroAnamnesiPatologicaEdit.vue?vue&type=template&id=4a693f4f"
import script from "./GastroAnamnesiPatologicaEdit.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiPatologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports